export default {
  SET_CATEGORIES: function (state, payloads) {
    state.categories = payloads;
  },
};
